import { ActionType, ParticipantType, TriggerType } from "../../../enums";
import { IAction, IParticipant, ISet, ITrigger } from "../../../types";
import { Set, Workflow } from "../../../workflowModel";
import { Action, CallMethod, CallScript, DateTimePrecision, IncrementDateTime, IncrementNumber, OpenForm, SendMail, SendSMS, SendWFMessage, SetAttribute, SetObjectAttribute, SetValue } from "../../../workflowModel/Actions";
import { Owner, Participant, Role, System, User } from "../../../workflowModel/Participants";
import { AttributeDataChange, Menu, NewObject, Text, Trigger, WfMessage } from "../../../workflowModel/Triggers";
import {
    CONST_ACTION_COMMENT_AT,
    CONST_ACTION_CONDITION_AT,
    CONST_ATTRIBUTE_DATA_CHANGE_ATTR_NAME_AT,
    CONST_ATTRIBUTE_DATA_CHANGE_CONDITION_AT,
    CONST_CALL_METHOD_DEFAULT_PARAM_VALUE_AT,
    CONST_CALL_METHOD_INSERT_ACTUAL_OBJECT_AT,
    CONST_CALL_METHOD_INSERT_PARAM_FORM_OBJECT_AT,
    CONST_CALL_METHOD_METHOD_NAME_AT,
    CONST_CALL_METHOD_STATIC_AT,
    CONST_CALL_SCRIPT_SCRIPT_AT,
    CONST_INCREMENT_DATE_TIME_ATTR_NAME_AT,
    CONST_INCREMENT_DATE_TIME_PRECISION_AT,
    CONST_INCREMENT_DATE_TIME_VALUE_AT,
    CONST_INCREMENT_NUMBER_ATTR_NAME_AT,
    CONST_INCREMENT_NUMBER_VALUE_AT,
    CONST_MENU_CAPTIONS_EL,
    CONST_MENU_CHOOSE_FROM_USERS_DEFAULT,
    CONST_MENU_CODE_NAME,
    CONST_MENU_CONFIRM_MESSAGES_EL,
    CONST_MENU_ICON_NAME,
    CONST_MENU_IDENTIFIER_AT,
    CONST_MENU_LINK_ATTR_FOR_SEL_OBJ_AT,
    CONST_MENU_MASTER_NODE_AT,
    CONST_MENU_MULTI_ACTION_ENABLE_AT,
    CONST_MENU_PARAM_FORM_NAME_AT,
    CONST_MENU_PARTICIPANTS_SELECTING_AT,
    CONST_MENU_SET_VALUES_AT,
    CONST_MENU_VALIDATE_POST_REQ_AT,
    CONST_MENU_VALIDATE_RECOMMENDED_AT,
    CONST_OPEN_FORM_FORM_CLASS_AT,
    CONST_OPEN_FORM_FORM_CONDITION_AT,
    CONST_OPEN_FORM_FORM_TYPE_AT,
    CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT,
    CONST_OPEN_FORM_REPORT_NAME_AT,
    CONST_SEND_MAIL_ATTR_NAME_AT,
    CONST_SEND_MAIL_CLASS_NAME_AT,
    CONST_SEND_MAIL_DATA_CONDITION_AT,
    CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT,
    CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT,
    CONST_SEND_MAIL_DOCUMENT_CONDITION_AT,
    CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT,
    CONST_SEND_MAIL_FORMAT_AT,
    CONST_SEND_MAIL_RECIPIENT_AT,
    CONST_SEND_MAIL_RECIPIENT_TYPE_AT,
    CONST_SEND_MAIL_REPORT_TEMPLATE_AT,
    CONST_SEND_MAIL_SEND_POSTPONE_AT,
    CONST_SEND_MAIL_SUBJECT_AT,
    CONST_SEND_MAIL_SUMMARY_MAIL_AT,
    CONST_SEND_MAIL_TEXT_AT,
    CONST_SEND_SMS_ATTR_NAME_AT,
    CONST_SEND_SMS_CLASS_NAME_AT,
    CONST_SEND_SMS_DATA_CONDITION_AT,
    CONST_SEND_SMS_RECIPIENT_AT,
    CONST_SEND_SMS_RECIPIENT_TYPE_AT,
    CONST_SEND_SMS_TEXT_AT,
    CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT,
    CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT,
    CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT,
    CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT,
    CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT,
    CONST_SET_ATTRIBUTE_ATTR_NAME_AT,
    CONST_SET_ATTRIBUTE_VALUE_EL,
    CONST_SET_ATTRIBUTE_VALUE_TYPE,
    CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT,
    CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT,
    CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT,
    CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL,
    CONST_SET_VALUE_NAME_AT,
    CONST_SET_VALUE_VALUE_EL,
    CONST_WFMESSAGE_DEACTIVATING_AT,
    CONST_WFMESSAGE_MESSAGE_NAME_AT,
} from "../../../workflowParser/constants";

export const createNewActions = async (actions: readonly IAction[]): Promise<Action[]> => {
    const newActions: Action[] = [];

    for (const action of actions) {
        switch (action.actionType) {
            case ActionType.CallMethod:
                newActions.push(new CallMethod(
                    action.properties[CONST_CALL_METHOD_METHOD_NAME_AT],
                    action.properties[CONST_CALL_METHOD_STATIC_AT],
                    action.properties[CONST_CALL_METHOD_INSERT_ACTUAL_OBJECT_AT],
                    action.properties[CONST_CALL_METHOD_INSERT_PARAM_FORM_OBJECT_AT],
                    action.properties[CONST_CALL_METHOD_DEFAULT_PARAM_VALUE_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.CallScript:
                newActions.push(new CallScript(
                    action.properties[CONST_CALL_SCRIPT_SCRIPT_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.IncrementValue: // Hloupé rozdělení, někdy v budoucnu by to chtělo refaktorovat. https://tfs.tescosw.loc/Jadro/Jadro%20.NET/_workitems/edit/30948
                if (action.properties[CONST_INCREMENT_DATE_TIME_PRECISION_AT] === DateTimePrecision.number)
                    newActions.push(new IncrementNumber(
                        action.properties[CONST_INCREMENT_NUMBER_ATTR_NAME_AT],
                        action.properties[CONST_INCREMENT_NUMBER_VALUE_AT],
                        action.properties[CONST_ACTION_CONDITION_AT],
                        action.properties[CONST_ACTION_COMMENT_AT],
                    ));
                else
                    newActions.push(new IncrementDateTime(
                        action.properties[CONST_INCREMENT_DATE_TIME_ATTR_NAME_AT],
                        action.properties[CONST_INCREMENT_DATE_TIME_PRECISION_AT],
                        action.properties[CONST_INCREMENT_DATE_TIME_VALUE_AT],
                        action.properties[CONST_ACTION_CONDITION_AT],
                        action.properties[CONST_ACTION_COMMENT_AT],
                    ));
                break;
            case ActionType.SendMail:
                newActions.push(new SendMail(
                    action.properties[CONST_SEND_MAIL_RECIPIENT_TYPE_AT],
                    action.properties[CONST_SEND_MAIL_RECIPIENT_AT],
                    action.properties[CONST_SEND_MAIL_CLASS_NAME_AT],
                    action.properties[CONST_SEND_MAIL_ATTR_NAME_AT],
                    action.properties[CONST_SEND_MAIL_DATA_CONDITION_AT],
                    action.properties[CONST_SEND_MAIL_SUBJECT_AT],
                    action.properties[CONST_SEND_MAIL_TEXT_AT],
                    action.properties[CONST_SEND_MAIL_REPORT_TEMPLATE_AT],
                    action.properties[CONST_SEND_MAIL_SUMMARY_MAIL_AT],
                    action.properties[CONST_SEND_MAIL_FORMAT_AT],
                    action.properties[CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT],
                    action.properties[CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT],
                    action.properties[CONST_SEND_MAIL_DOCUMENT_CONDITION_AT],
                    action.properties[CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT],
                    action.properties[CONST_SEND_MAIL_SEND_POSTPONE_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.SendSMS:
                newActions.push(new SendSMS(
                    action.properties[CONST_SEND_SMS_RECIPIENT_AT],
                    action.properties[CONST_SEND_SMS_CLASS_NAME_AT],
                    action.properties[CONST_SEND_SMS_ATTR_NAME_AT],
                    action.properties[CONST_SEND_SMS_DATA_CONDITION_AT],
                    action.properties[CONST_SEND_SMS_TEXT_AT],
                    action.properties[CONST_SEND_SMS_RECIPIENT_TYPE_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.SendWFMessage:
                newActions.push(new SendWFMessage(
                    action.properties[CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT],
                    action.properties[CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT],
                    action.properties[CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT],
                    action.properties[CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT],
                    action.properties[CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.SetAttribute:
                newActions.push(new SetAttribute(
                    action.properties[CONST_SET_ATTRIBUTE_ATTR_NAME_AT],
                    action.properties[CONST_SET_ATTRIBUTE_VALUE_EL],
                    action.properties[CONST_SET_ATTRIBUTE_VALUE_TYPE],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.SetObjectAttribute:
                newActions.push(new SetObjectAttribute(
                    action.properties[CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT],
                    action.properties[CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL],
                    action.properties[CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT],
                    action.properties[CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.SetValue:
                newActions.push(new SetValue(
                    action.properties[CONST_SET_VALUE_NAME_AT],
                    action.properties[CONST_SET_VALUE_VALUE_EL],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            case ActionType.OpenForm:
                newActions.push(new OpenForm(
                    action.properties[CONST_OPEN_FORM_FORM_TYPE_AT],
                    action.properties[CONST_OPEN_FORM_FORM_CLASS_AT],
                    action.properties[CONST_OPEN_FORM_REPORT_NAME_AT],
                    action.properties[CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT],
                    action.properties[CONST_OPEN_FORM_FORM_CONDITION_AT],
                    action.properties[CONST_ACTION_CONDITION_AT],
                    action.properties[CONST_ACTION_COMMENT_AT],
                ));
                break;
            default:
                throw new Error(`Saving function for action type '${action.actionType}' is not implemented!`);
        }

        await newActions[newActions.length - 1].validate();
    }

    return newActions;
};

/**
 * Funkce se stará o "uložení" spouštěčů. Podrobněji dělá to, že pro každý spouštěč z reduxího storu vytvoří jeho mutable instanční verzi,
 * kde se kontrolu, jestli každý atribut obsahuje potřebné atributy, atp.
 * @param triggers Množina triggerů z redux storu.
 */
export const createNewTriggers = async (triggers: readonly ITrigger[]): Promise<Trigger[]> => {
    const newTriggers: Trigger[] = [];

    for (const trigger of triggers) {
        switch (trigger.triggerType) {
            case TriggerType.AttributeDataChange:
                newTriggers.push(new AttributeDataChange(
                    trigger.properties[CONST_ATTRIBUTE_DATA_CHANGE_ATTR_NAME_AT],
                    trigger.properties[CONST_ATTRIBUTE_DATA_CHANGE_CONDITION_AT]));
                break;
            case TriggerType.Menu:
                newTriggers.push(new Menu(
                    trigger.properties[CONST_MENU_IDENTIFIER_AT],
                    trigger.properties[CONST_MENU_CODE_NAME],
                    trigger.properties[CONST_MENU_ICON_NAME],
                    trigger.properties[CONST_MENU_PARTICIPANTS_SELECTING_AT],
                    trigger.properties[CONST_MENU_MULTI_ACTION_ENABLE_AT],
                    trigger.properties[CONST_MENU_VALIDATE_POST_REQ_AT],
                    trigger.properties[CONST_MENU_VALIDATE_RECOMMENDED_AT],
                    trigger.properties[CONST_MENU_CHOOSE_FROM_USERS_DEFAULT],
                    trigger.properties[CONST_MENU_MASTER_NODE_AT],
                    trigger.properties[CONST_MENU_PARAM_FORM_NAME_AT],
                    trigger.properties[CONST_MENU_LINK_ATTR_FOR_SEL_OBJ_AT],
                    trigger.properties[CONST_MENU_SET_VALUES_AT],
                    JSON.parse(trigger.properties[CONST_MENU_CAPTIONS_EL]) as Text[],
                    JSON.parse(trigger.properties[CONST_MENU_CONFIRM_MESSAGES_EL]) as Text[]));
                break;
            case TriggerType.NewObject:
                newTriggers.push(new NewObject());
                break;
            case TriggerType.WfMessage:
                newTriggers.push(new WfMessage(
                    trigger.properties[CONST_WFMESSAGE_MESSAGE_NAME_AT],
                    trigger.properties[CONST_WFMESSAGE_DEACTIVATING_AT]));
                break;
            default:
                throw new Error(`Saving function for trigger type '${trigger.triggerType}' is not implemented!`);
        }

        await newTriggers[newTriggers.length - 1].validate();
    }

    return newTriggers;
};

export const createNewParticipants = (workflow: Workflow, participants: readonly IParticipant[]): Participant[] => {
    const newParticipants: Participant[] = [];

    participants.forEach(participant => {
        switch (participant.participantType) {
            case ParticipantType.DefinitionParticipant: {
                const foundDefParticipant = workflow.definitionParticipants.find(wfDefPaticipant => wfDefPaticipant.identifier === participant.identifier);
                if (!foundDefParticipant)
                    throw new Error(`Could not find definition participant of the name '${participant.properties["identifier"]}'!`);
                newParticipants.push(foundDefParticipant);
                break;
            }
            case ParticipantType.Owner:
                newParticipants.push(new Owner());
                break;
            case ParticipantType.System:
                newParticipants.push(new System());
                break;
            case ParticipantType.Role:
                newParticipants.push(new Role(
                    participant.properties["dbID"],
                    participant.properties["name"]));
                break;
            case ParticipantType.User:
                newParticipants.push(new User(
                    participant.properties["dbID"],
                    participant.properties["name"]));
                break;
            default:
                throw new Error(`Saving function for participant type '${participant.participantType}' is not implemented!`);
        }
    });

    return newParticipants;
};

/**
 * Stará se o uložení změn ze storu do mutable verze workflow.
 * @param sets Editované sady z redux storu.
 * @param workflow Objekt workflow.
 */
export const saveSets = (sets: readonly ISet[], workflow: Workflow) => {
    const orderedSets: Set[] = []; // Musíme uspořádat sady, protože na serveru je pořádí bráno jako ID... :/ Snad se někdy smaže

    // Napřed smažeme odebrané sady
    workflow.sets.forEach(wfState => {
        const stateSet = sets.find(set => set.id === wfState.id);

        if (stateSet === undefined)
            workflow.removeSet(wfState.id);
    });

    // Pak vytvoříme přidané sady a upravíme ty existující
    sets.forEach(stateSet => {
        const wfSet = workflow.sets.find(set => set.id === stateSet.id);

        if (wfSet === undefined) {
            workflow.addSet(stateSet.name, stateSet.description, stateSet.id);
            orderedSets.push(workflow.sets[workflow.sets.length - 1]);
        } else {
            wfSet.name = stateSet.name;
            wfSet.description = stateSet.description;
            orderedSets.push(wfSet);
        }
    });

    workflow.sets = orderedSets;
};
